export default {
  title: "Easy Air Screen",
  subtitle: "태블릿을 Mac 무선 보조 모니터로",
  description:
    "Mac 화면을 태블릿으로 확장하거나 미러링하세요. 같은 Wi-Fi에서 연결하고, 한 번만 구매하면 Mac용 앱은 무료예요.",
  downloadMobile: "모바일 앱 다운로드",
  purchasePromise: "한 번만 구매하세요. 구독과 광고는 없어요.",
  companionPromise: "Mac용 동반 앱은 무료이고, 계정도 필요하지 않아요.",
  downloadMacOS: "macOS용 다운로드 (Universal)",
  quickSetup: "빠른 설정",
  setupSteps: [
    "태블릿에 Easy Air Screen 설치",
    "macOS용 데스크톱 앱 다운로드 및 설치",
    "두 기기를 동일한 Wi-Fi 네트워크에 연결",
    "실행 후 연결하세요!",
  ],
  performanceTip: "성능 팁",
  performanceDescription:
    "최소한의 지연으로 최상의 경험을 위해 두 기기 모두에서 5GHz Wi-Fi 연결을 사용하세요. 지연이 발생하면 앱 설정에서 해상도를 낮춰보세요.",
  faqTitle: '자주 묻는 질문',
  faq: [
    {
      q: 'Sidecar와 무엇이 다른가요?',
      a: 'Easy Air Screen은 두 기기의 Apple ID가 달라도 연결할 수 있어요. Android 태블릿도 Mac의 무선 보조 화면으로 사용할 수 있어요.'
    },
    {
      q: 'Android 태블릿에서도 쓸 수 있나요?',
      a: '네, Android 태블릿을 Mac의 무선 보조 모니터로 쓸 수 있어요. 같은 Wi-Fi에 연결한 뒤 화면을 확장하거나 복제할 수 있어요.'
    },
    {
      q: 'iPhone도 보조 화면이 되나요?',
      a: '네, iPhone도 Mac의 무선 보조 화면으로 사용할 수 있어요. 필요에 따라 화면 확장과 복제 중 원하는 방식을 고를 수 있어요.'
    },
    {
      q: '화면 확장인가요, 미러링인가요?',
      a: '둘 다 지원해요. Mac 화면을 다른 화면으로 확장하거나, 현재 화면을 그대로 복제해서 볼 수 있어요.'
    },
    {
      q: '인터넷 연결이 필요한가요? 화면이 외부로 나가나요?',
      a: '인터넷 연결은 필요하지 않아요. 같은 Wi-Fi 안에서 직접 연결하며, 화면은 외부 서버를 거치거나 저장되지 않아요.'
    },
    {
      q: '구독 서비스인가요?',
      a: '아니요, 기기 앱은 한 번만 구매하면 돼요. 구독이 아니며 광고도 없고, Mac용 동반 앱은 무료로 사용할 수 있어요.'
    },
    {
      q: 'Windows PC에서도 사용할 수 있나요?',
      a: '아니요, Easy Air Screen은 macOS 전용이에요. Windows PC는 현재 지원하지 않아요.'
    },
    {
      q: '화면이 끊기거나 느릴 때는 어떻게 하나요?',
      a: '두 기기를 5GHz Wi-Fi에 연결해 보세요. 그래도 지연이 느껴지면 앱 설정에서 해상도를 낮추면 도움이 될 수 있어요.'
    },
  ]
};
